import { EMPTY, ignoreElements } from 'rxjs';

export const emptyAction = () => EMPTY.pipe(ignoreElements());
